import { render, staticRenderFns } from "./full-screen-centered-card.vue?vue&type=template&id=ecfe0214&scoped=true&"
import script from "./full-screen-centered-card.vue?vue&type=script&lang=js&"
export * from "./full-screen-centered-card.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-centered-card.vue?vue&type=style&index=0&id=ecfe0214&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfe0214",
  null
  
)

export default component.exports